import { GetCurrentCompanyBillingQuery } from "@/graphql/generated/graphql";
import { GetCurrentCompanyBilling } from "@/graphql/queries/GetCurrentCompanyBilling";
import { useGraphQuery } from "@dashboard/library";
import { UseCurrentCompanyBillingReturn } from "./useCurrentCompanyBilling.decl";

/**
 * Hook to get the current company billing data from the REST proxy.
 * Kept separate from useCurrentCompany so a billing failure does not
 * block consumers that only need the company core fields (id, plan, etc).
 */
export function useCurrentCompanyBilling(): UseCurrentCompanyBillingReturn {
  const { data, loading } = useGraphQuery<GetCurrentCompanyBillingQuery>(
    GetCurrentCompanyBilling
  );

  return {
    loading,
    currentCompanyBilling: data?.currentCompanyBilling,
  };
}
